// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGUnlinkIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGUnlinkIcon extends PureComponent<
  ISVGUnlinkIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M28.591,0.03c0.599,0.035,1.24,0.059,1.755,0.218
	c2.136,0.66,3.492,2.081,4.238,4.168c0.268,0.747,0.487,1.984,0.257,2.953C34.74,7.795,34.66,8.272,34.5,8.672
	c-0.784,1.939-2.454,3.183-3.811,4.56c-0.712,0.723-1.426,1.447-2.14,2.171c-0.438,0.443-0.855,0.939-1.37,1.302
	c-1.032,0.729-2.95,1.428-4.709,0.956c-0.449-0.121-1.063-0.127-1.327-0.434c0.572-0.564,1.142-1.129,1.713-1.694
	c0.229-0.308,0.536-0.803,1.027-0.825c0.134-0.084,0.337-0.032,0.513-0.086c0.335-0.102,0.755-0.281,1.028-0.477
	c0.496-0.359,0.898-0.911,1.327-1.347c0.928-0.941,1.855-1.881,2.782-2.821c0.75-0.761,1.707-1.451,2.14-2.52
	c0.487-1.198-0.076-2.507-0.599-3.213c-0.565-0.763-2.174-1.454-3.468-0.911c-1.067,0.448-1.763,1.441-2.525,2.214
	c-1.299,1.303-2.597,2.605-3.896,3.908c-0.385,0.52-0.707,1.163-0.728,2.041c-0.281,0.188-0.422,0.536-0.686,0.738
	c-0.452,0.347-0.802,0.771-1.198,1.173c-0.196,0.199-0.444,0.368-0.599,0.607c-0.015,0-0.029,0-0.042,0c0-0.015,0-0.029,0-0.043
	c-0.757-0.953-0.543-3.756-0.086-4.863c0.793-1.919,2.773-3.465,4.152-4.864c1.046-1.061,2.12-2.45,3.381-3.256
	c0.584-0.372,1.318-0.628,2.055-0.826C27.726,0.083,28.374,0.169,28.591,0.03z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M13.78,5.458c0.268,0.001,0.36,0.076,0.556,0.131
	c0.651,1.086,0.798,2.834,1.199,4.168c0.174,0.575,0.437,1.183,0.3,1.824c-0.244,0.165-0.335,0.303-0.771,0.304
	c-0.059-0.048-0.123-0.065-0.215-0.086c-0.707-1.03-0.82-2.846-1.241-4.169c-0.183-0.574-0.457-1.203-0.3-1.866
	C13.444,5.677,13.648,5.569,13.78,5.458z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M8.856,8.368c0.665,0.007,0.863,0.484,1.199,0.824
	c0.771,0.783,1.541,1.564,2.311,2.346c0.281,0.284,0.848,0.603,0.899,1.085c0.097,0.146-0.005,0.333-0.042,0.479
	c-0.208,0.151-0.534,0.535-0.899,0.259c-0.386-0.138-0.707-0.673-0.985-0.955c-0.756-0.767-1.512-1.534-2.269-2.301
	C8.729,9.757,8.304,9.59,8.3,8.889c0.101-0.107,0.138-0.307,0.257-0.391C8.65,8.433,8.774,8.435,8.856,8.368z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M5.903,13.361c0.613-0.016,1.039,0.196,1.499,0.348
	c0.969,0.321,1.975,0.489,2.911,0.782c0.488,0.152,1.215,0.122,1.369,0.608c0.087,0.109,0.09,0.27,0.086,0.477
	c-0.145,0.163-0.152,0.352-0.385,0.433c-0.228,0.184-1.119-0.075-1.413-0.173c-1.031-0.345-2.174-0.586-3.21-0.912
	c-0.418-0.132-1.059-0.112-1.199-0.521C5.167,13.991,5.684,13.565,5.903,13.361z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M10.912,17.617c1.208-0.026,2.132,0.166,2.954,0.521
	c-0.039,0.047,0.003,0.003-0.043,0.044c-0.425,0.662-1.204,1.069-1.67,1.693c-0.216,0.29-0.536,0.793-0.984,0.824
	c-0.142,0.089-0.375,0.031-0.556,0.087c-0.335,0.102-0.755,0.282-1.028,0.478c-0.496,0.359-0.898,0.911-1.327,1.347
	c-0.927,0.94-1.855,1.881-2.782,2.822c-0.75,0.761-1.708,1.45-2.141,2.518c-0.469,1.157,0.047,2.476,0.557,3.17
	c0.572,0.78,2.179,1.515,3.51,0.956c1.066-0.449,1.764-1.442,2.525-2.215c1.298-1.303,2.597-2.605,3.896-3.908
	c0.389-0.527,0.692-1.159,0.728-2.041c0.281-0.188,0.421-0.537,0.686-0.738c0.452-0.347,0.802-0.771,1.198-1.173
	c0.197-0.199,0.444-0.369,0.599-0.608c0.047,0.04,0.004-0.003,0.044,0.043c0.226,0.286,0.232,0.723,0.342,1.13
	c0.495,1.825-0.134,3.838-0.899,4.949c-0.719,1.045-1.773,1.887-2.654,2.78c-0.771,0.782-1.542,1.563-2.312,2.344
	c-0.889,0.901-1.692,1.767-2.954,2.301c-1.02,0.433-2.744,0.586-3.938,0.218c-0.694-0.215-1.418-0.563-1.969-0.956
	c-1.934-1.377-3.41-4.619-2.098-7.686c0.702-1.638,2.13-2.725,3.297-3.907c0.813-0.825,1.626-1.651,2.439-2.476
	c0.48-0.487,0.935-1.033,1.498-1.433c0.546-0.387,1.28-0.703,1.969-0.911C10.121,17.693,10.636,17.792,10.912,17.617z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M23.754,19.311c0.537-0.008,0.991,0.208,1.413,0.347
	c0.968,0.321,1.976,0.489,2.911,0.781c0.455,0.142,1.218,0.122,1.371,0.564c0.393,0.413-0.123,0.839-0.343,1.042
	c-0.612,0.017-1.039-0.195-1.499-0.348c-0.971-0.322-1.978-0.474-2.91-0.781c-0.493-0.163-1.212-0.114-1.37-0.608
	c-0.086-0.109-0.09-0.269-0.086-0.477c0.145-0.163,0.152-0.352,0.386-0.435C23.659,19.367,23.721,19.339,23.754,19.311z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M22.256,21.959c0.178-0.004,0.329,0.01,0.428,0.086
	c0.387,0.139,0.707,0.674,0.984,0.956c0.756,0.767,1.513,1.534,2.269,2.301c0.343,0.348,0.767,0.514,0.771,1.215
	c-0.132,0.149-0.13,0.315-0.342,0.392c-0.119,0.112-0.278,0.132-0.514,0.129C24.73,26.121,23.783,25.028,22.77,24
	c-0.306-0.311-0.97-0.697-1.027-1.216c-0.097-0.147,0.003-0.332,0.042-0.478C21.932,22.21,22.114,22.08,22.256,21.959z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M19.602,23.522c0.253-0.003,0.377,0.042,0.557,0.087
	c0.696,1.015,0.845,2.851,1.241,4.168c0.176,0.583,0.458,1.196,0.299,1.867c-0.228,0.155-0.333,0.296-0.728,0.304
	c-0.077-0.063-0.188-0.102-0.299-0.13c-0.65-1.087-0.798-2.835-1.199-4.168c-0.173-0.577-0.437-1.183-0.3-1.824
	C19.299,23.747,19.493,23.629,19.602,23.522z"
        />
      </svg>
    );
  }
}
